import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {Box, Container, List, Typography} from '@mui/material';
import { Button } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { route } from '/@/app/routes';

import { AppContext } from '/@/app/AppContext';


export const PaymentSuccessView = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const goBack = () => {
        // FIXME navigate to some welcome / onboarding page for paid users
        navigate(route('/'));
    };
    const { bootstrapData } = useContext(AppContext);

    return (
        <Container maxWidth="lg" sx={{ mb: 10 }}>
            <Typography variant="h2" sx={{ textAlign: 'center' }} gutterBottom>
                Оплата успешна.
            </Typography>
            <Typography variant="body1" sx={{ textAlign: 'center' }} gutterBottom>
                Вы можете пользоваться новыми фичами.
            </Typography>
	    { bootstrapData.subscriptions?.promocodes?.length>0
	        && (
<Box sx={{textAlign:'center', marginTop:2}}>
<Typography variant="h4">{t('Ваши промокоды')}</Typography>
<Typography variant="body2" >{t('(см. Подписки)')}</Typography>
<TableContainer sx={{ width: 'fit-content', maxWidth: '100%', mx:'auto' }}>
<Table>
<TableHead>
    <TableRow>
	<TableCell>{t('Код')}</TableCell>
	<TableCell>{t('Промо кампания')}</TableCell>
	<TableCell>{t('Истекает')}</TableCell>
    </TableRow>
</TableHead>
    <TableBody>
			{
	bootstrapData.subscriptions.promocodes.map((promocode) => (
	    <TableRow key={promocode.id}>
		<TableCell sx={{fontSize:'1.5em'}}>{promocode['code']}</TableCell>
		<TableCell>{promocode['name']}</TableCell>
		<TableCell>{promocode['expire'] || t('никогда')}</TableCell>
	    </TableRow>
	))
			}
    </TableBody>
</Table>
</TableContainer>
</Box>
	        )
	    }
            <Box
                sx={{
                    mt: 2,
                    display: 'flex',
                    justifyContent: 'center',
                }}
                onClick={goBack}
            >
                <Button><ArrowBackIcon sx={{ mr:1 }}/>Вернуться</Button>
            </Box>
        </Container>
    )
}
